module.exports = __webpack_public_path__ + "static/media/29ADMSPC23.6e6253c6.jpg";